const Footer = () => {
  return (
    // <footer className='d-flex flex-wrap justify-content-between align-items-center py-3 my-4 border-top'>
    //   <div className='container-fluid'>
    //   <div className="row">
    //     <div className='col-md-4 d-flex align-items-center'>
    //       <span className='text-muted'>© 2025 Filename Builder, Inc</span>
    //     </div>
    //     <ul className='nav col-md-8 justify-content-end list-unstyled d-flex'>
    //       <li className='ms-3'>
    //         <a className='mb-3 me-2 mb-md-0 text-decoration-none lh-1' href='https://twitter.com'>
    //           <svg className='bi' width={24} height={24}>
    //             <use xlinkHref='#twitter' />
    //           </svg>
    //           Twitter
    //         </a>
    //       </li>
    //       <li className='ms-3'>
    //         <a className='mb-3 me-2 mb-md-0 text-decoration-none lh-1' href='https://instagram.com'>
    //           <svg className='bi' width={24} height={24}>
    //             <use xlinkHref='#instagram' />
    //           </svg>
    //           Instagram
    //         </a>
    //       </li>
    //       <li className='ms-3'>
    //         <a className='mb-3 me-2 mb-md-0 text-decoration-none lh-1' href='https://facebook.com'>
    //           <svg className='bi' width={24} height={24}>
    //             <use xlinkHref='#facebook' />
    //           </svg>
    //           Facebook
    //         </a>
    //       </li>
    //     </ul>
    //   </div>
    //   </div>
    // </footer>
    <div className="position-relative mt-10 mt-lg-15">
      <div
        className="bg-holder footer-bg"
        style={{ backgroundImage: 'url(../../assets/img/bg/bg-19.png)', backgroundSize: 'auto' }}
      ></div>
      <div className="position-relative">
        <svg
          className="w-100 text-white dark__text-gray-1100"
          preserveAspectRatio="none"
          viewBox="0 0 1920 368"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M1920 0.44L0 367.74V0H1920V0.44Z" fill="currentColor"></path>
        </svg>
        <section className="footer-default">
          <div className="container-small px-lg-7 px-xxl-3">
            <div className="row position-relative">
              <div className="col-12 col-sm-12 col-lg-5 mb-4 order-0 order-sm-0">
                <a href="#">
                  <img
                    className="mb-3"
                    src="../../assets/img/icons/logo-white.png"
                    height="48"
                    alt=""
                  />
                </a>
                <h3 className="text-white">Filename</h3>
              </div>
              <div className="col-lg-7">
                <div className="row justify-content-between">
                  <div className="col-6 col-sm-4 col-lg-3 mb-3 order-2 order-sm-1">
                    <div
                      className="border-dashed border-start border-primary-light ps-3"
                      style={{ '--phoenix-border-opacity': 0.2 }}
                    >
                      <h5 className="fw-bolder mb-2 text-light">Help</h5>
                      <ul className="list-unstyled mb-3">
                        <li className="mb-1">
                          <a className="text-body-quaternary" href="#!" data-bs-theme="light">
                            About
                          </a>
                        </li>
                        <li className="mb-1">
                          <a className="text-body-quaternary" href="#!" data-bs-theme="light">
                            Contact
                          </a>
                        </li>
                        <li className="mb-1">
                          <a className="text-body-quaternary" href="#!" data-bs-theme="light">
                            Developers
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-6 col-sm-4 col-lg-3 mb-3 order-3 order-sm-2">
                    <div
                      className="border-dashed border-start border-primary-light ps-3"
                      style={{ '--phoenix-border-opacity': 0.2 }}
                    >
                      <h5 className="lh-lg fw-bold text-light mb-2">Support</h5>
                      <ul className="list-unstyled mb-md-2">
                        <li className="mb-1">
                          <a className="text-body-quaternary" href="#!" data-bs-theme="light">
                            Privacy
                          </a>
                        </li>
                        <li className="mb-1">
                          <a className="text-body-quaternary" href="#!" data-bs-theme="light">
                            Contact
                          </a>
                        </li>
                        <li className="mb-1">
                          <a className="text-body-quaternary" href="#!" data-bs-theme="light">
                            FAQ
                          </a>
                        </li>
                        <li className="mb-1">
                          <a className="text-body-quaternary" href="#!" data-bs-theme="light">
                            Project
                          </a>
                        </li>
                        <li className="mb-1">
                          <a className="text-body-quaternary" href="#!" data-bs-theme="light">
                            Team
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-6 col-sm-4 col-lg-3 mb-3 order-3 order-sm-2">
                    <div
                      className="border-dashed border-start border-primary-light ps-3"
                      style={{ '--phoenix-border-opacity': 0.2 }}
                    >
                      <h5 className="lh-lg fw-bolder mb-2 text-light">Follow</h5>
                      <ul className="list-unstyled mb-2">
                        <li className="mb-1">
                          <a className="text-body-quaternary" href="#!" data-bs-theme="light">
                            Facebook
                          </a>
                        </li>
                        <li className="mb-1">
                          <a className="text-body-quaternary" href="#!" data-bs-theme="light">
                            Twitter
                          </a>
                        </li>
                        <li className="mb-1">
                          <a className="text-body-quaternary" href="#!" data-bs-theme="light">
                            Linkedin
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Footer;
